import React from 'react';
import { Button, ButtonGroup, Flex, Icon } from '@chakra-ui/react';
import PropTypes from 'prop-types';

/**
 * CommonTabSwitcher — shared tab switcher used across all list pages.
 * Consistent modern style: attached ButtonGroup with icon + label per tab.
 * Active tab: reviveOrange fill. Inactive: white with gray border.
 */
const CommonTabSwitcher = ({ tabs, activeIndex, onChange, mb }) => (
  <Flex mb={mb ?? 4} align="center">
    <ButtonGroup isAttached variant="outline" size="sm">
      {tabs.map((tab, index) => {
        const isActive = activeIndex === index;
        return (
          <Button
            key={tab.label}
            onClick={() => onChange(index)}
            bg={isActive ? 'reviveOrange' : 'white'}
            color={isActive ? 'white' : 'gray.600'}
            borderColor={isActive ? 'reviveOrange' : 'gray.200'}
            _hover={{
              bg: isActive ? 'reviveOrange' : 'gray.50',
              opacity: isActive ? 0.85 : 1,
            }}
            _active={{ opacity: 0.7 }}
            fontWeight="600"
            px={5}
            leftIcon={
              tab.icon ? <Icon as={tab.icon} w="13px" h="13px" /> : undefined
            }
          >
            {tab.label}
            {tab.badge !== null &&
              tab.badge !== undefined &&
              tab.badge > 0 &&
              isActive && (
                <Flex
                  as="span"
                  ml={2}
                  bg="white"
                  color="reviveOrange"
                  borderRadius="full"
                  fontSize="10px"
                  fontWeight="700"
                  minW="18px"
                  h="18px"
                  align="center"
                  justify="center"
                  px={1}
                >
                  {tab.badge}
                </Flex>
              )}
          </Button>
        );
      })}
    </ButtonGroup>
  </Flex>
);

CommonTabSwitcher.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.elementType,
      badge: PropTypes.number,
    }),
  ).isRequired,
  activeIndex: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  mb: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default CommonTabSwitcher;
